import slugify from "slugify";

export default {
  get_slug(string) {
    return slugify(string, {
      replacement: "-",
      remove: undefined,
      lower: true,
      strict: false,
    });
  },
};
